import { useState, Fragment } from 'react';
import { usePopper } from 'react-popper';
import { Popover, Transition } from '@headlessui/react';
import { NavLink } from 'react-router-dom';
import { CheckmarkIcon } from '../../../misc/icons/Icons';
import useTranslation from '../../../../hooks/useTranslations';

const PopupWrapper = ({
	children, button, items, width, maxHeight, placement, skidding, distance, wrapperClasses = '', wrapperStyles,
}) => {
	const [referenceElement, setReferenceElement] = useState();
	const [popperElement, setPopperElement] = useState();
	const [arrowElement, setArrowElement] = useState(null);
	const { styles, attributes } = usePopper(referenceElement, popperElement, {
		placement,
		modifiers: [
			{
				name: 'arrow',
				options: { element: arrowElement },
			},
			{
				name: 'offset',
				options: {
					offset: [skidding, distance],
				},
			},
			{
				name: 'preventOverflow',
				options: {
					altAxis: true,
					padding: 10,
				},
			},
		],
	});

	return (
		<Popover className={`relative w-full sm:w-auto ${wrapperClasses}`} style={wrapperStyles}>
			<Popover.Button
				ref={setReferenceElement}
				className="block w-full focus:outline-none sm:w-auto relative z-10"
			>
				{button}
			</Popover.Button>
			<Popover.Panel
				ref={setPopperElement}
				style={styles.popper}
				{...attributes.popper}
				className="popover z-50"
			>
				<Transition
					as={Fragment}
					enter="transition ease-out duration-200"
					enterFrom="opacity-0 translate-y-1"
					enterTo="opacity-100 translate-y-0"
					leave="transition ease-in duration-150"
					leaveFrom="opacity-100 translate-y-0"
					leaveTo="opacity-0 translate-y-1"
				>
					<div className="">
						<div ref={setArrowElement} style={styles.arrow} className="popover-arrow" />
						<div className={`overflow-hidden rounded-lg shadow-popover ${width}`}>
							<div className={`relative overflow-y-auto bg-white divide-y divide-oly-gray-lightest ${maxHeight}`}>
								{children}
								{items.map((item) => (item))}
							</div>
						</div>
					</div>
				</Transition>
			</Popover.Panel>
		</Popover>
	);
};

export const PopoverItem = ({ id, title, isActive, callback }) => {
	const t = useTranslation();
	return (
		<button
			type="button"
			onClick={() => callback({ id, isActive })}
			className="flex items-center justify-between w-full h-12 p-2 text-left sm:p-3 sm:h-16 can-hover:hover:bg-oly-gray-lightestAlpha45 focus-visible:bg-oly-gray-lightestAlpha45 focus:outline-none"
			aria-labelledby={title}
		>
			<span className="leading-4 sm:leading-5 text-[0.75rem] sm:text-[0.9375rem] font-semibold text-oly-gray-darkest mr-2 line-clamp-2">{t(title)}</span>
			{isActive && <CheckmarkIcon className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5 text-oly-blue-dark" />}
			{!isActive && <div className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5 text-oly-blue-dark" />}
		</button>
	);
};

export const PopoverNavItem = ({ title, route }) => {
	const t = useTranslation();
	return (
		<NavLink
			to={route}
			className="flex items-center justify-between w-full h-12 p-2 text-left sm:p-3 sm:h-16 can-hover:hover:bg-oly-gray-lightestAlpha45 focus-visible:bg-oly-gray-lightestAlpha45 focus:outline-none"
		>
			<span className="leading-4 sm:leading-5 text-[0.75rem] sm:text-[0.9375rem] font-semibold text-oly-gray-darkest mr-2 line-clamp-2">{t(title)}</span>
		</NavLink>
	);
};

export default PopupWrapper;
